import modules from './modules';
import * as authorApi from '@authoringPlatform/../api/authors';
import Vue from 'vue';
import { isMilestoneAchieved } from '@authoringPlatform/../utils/iapValidation';

export default {
  state: {
    alert: {
      message: '',
      isActive: false,
      isWarning: false,
    },
    milestones: [],
    remainingMilestones: [],
    playOnboard: true,
    isEditMode: false,
    isLoading: false,
  },

  modules,

  actions: {
    notify: ({ commit }, { message, isWarning }) => {
      if (isWarning) {
        let alert = { message, isWarning, isActive: true };
        commit('SET_ALERT', alert);
        setTimeout(
          () => commit('SET_ALERT', { message: '', isWarning: false, isActive: false }),
          5000
        );
      } else {
        setTimeout(() => commit('SET_IS_SAVING', false), 1000);
      }
    },
    getMilestonesForAuthor: async ({ commit }, { authorKey }) => {
      const milestonesData = await authorApi.getMilestonesForAuthor(authorKey);

      commit('SET_MILESTONE', milestonesData);
    },
    getRemainingMilestonesForAuthor: async ({ commit, state }, { authorKey }) => {
      state.isLoading = true;
      const res = await authorApi.getRemainingMilestones(authorKey);
      state.isLoading = false;
      commit('SET_REMAINING_MILESTONE', res);
    },
    SET_MILESTONE: async (
      { commit, rootState, state },
      { message, tooltipDesc, timeout, style, milestoneKey, bypass = false }
    ) => {
      const isNotifAllow = !isMilestoneAchieved(state.milestones, milestoneKey) || bypass;

      if (isNotifAllow) {
        const icon = '/capsiminbox/images/IAP-Dashboard_Icon_check_small2.svg';
        const defaultMessage = 'New Authoring Milestone Achieved:';
        const alert = {
          message: defaultMessage,
          tooltipDesc,
          linkText: message,
          isInfor: true,
          icon,
          isActive: true,
          style: style,
        };
        commit('SET_ALERT', alert);

        const payload = {
          time: new Date(),
          actorKey: rootState.user.actorKey,
          description: message,
          milestoneKey,
        };

        await authorApi.setMilestoneForAuthor(payload);

        const milestonesCopy = [...state.milestones];
        let remainingData = [...state.remainingMilestones];
        milestonesCopy.unshift(payload);
        let idxToRemove = remainingData.findIndex(
          (item) => item.milestoneKey === payload.milestoneKey
        );
        remainingData.splice(idxToRemove, 1);

        commit('SET_REMAINING_MILESTONE', remainingData);
        commit('SET_MILESTONE', milestonesCopy);

        setTimeout(
          () =>
            commit('SET_ALERT', {
              message: '',
              tooltipDesc,
              linkText: message,
              isInfor: false,
              isActive: false,
            }),
          timeout
        );
      }
    },
  },

  mutations: {
    SET_MILESTONE: (state, milestones) => {
      Vue.set(state, 'milestones', milestones);
    },
    SET_REMAINING_MILESTONE: (state, milestones) => {
      Vue.set(state, 'remainingMilestones', milestones);
    },
    SET_EDIT_MODE: (state, isEditMode) => {
      state.isEditMode = isEditMode;
    },

    SET_ALERT: (state, alert) => {
      state.alert = alert;
    },

    SET_VIDEO_PLAY: (state, payload) => (state.playOnboard = payload),
  },
};
